export const CITATION_COPY_BUTTON_TEXT = {
  default: "Copy citation",
  copied: "Citation copied",
};

export const CITATION_OPTION_VALUES = {
  MLA: { name: "MLA", panelId: "mla", tab: "mla_tab" },
  APA: { name: "APA", panelId: "apa", tab: "apa_tab" },
  CHICAGO: { name: "Chicago", panelId: "chicago", tab: "chicago_tab" },
};

export const CITATION_DEFAULT_WEBSITE_TITLE = "Newsela";
